import { FileSystemEntry, FileSystemFileEntry, IFile } from './interfaces';

export class FileDropEntry {
    public size: number;
    public rootFolder: string;
    public file: IFile;
    public extension: string;

    constructor(
        public relativePath: string,
        public fileEntry: FileSystemEntry,
    ) { }

    public buildMetaFromFile(): Promise<void> {
        return new Promise(resolve => {
            const fileEntryTemp = this.fileEntry as FileSystemFileEntry;
            fileEntryTemp.file(file => {
                if (file.webkitRelativePath) {
                    this.relativePath = file.webkitRelativePath;
                    this.rootFolder = this.relativePath.includes('/') ? this.relativePath.split('/')[0] : null;
                } else if (this.fileEntry.isFile) {
                    this.rootFolder = this.relativePath.includes('/') ? this.relativePath.split('/')[0] : null;
                }
                this.size = file.size;
                this.file = file;
                this.extension = this.file.name.split('.')[this.file.name.split('.').length - 1];
                resolve();
            });
        });
    }

}
